import { CardGridContainer } from "@affinity/components/ProductList/ProductListCardGrid";
import { AddressType } from "@affinity/constants/SharedTypes";
import AddAddress from "@affinity/Handlers/AddAddress";
import SwitchAddressMode from "@affinity/Handlers/SwitchAddressMode";
import { CustomState } from "@affinity/Store/Reducers";
import { AddAdressButton } from "@affinity/Widgets/Addresses/AddAdressButton";
import { AddressCard } from "@affinity/Widgets/Addresses/AddressCard";
import { AddressLookup } from "@affinity/Widgets/Addresses/AddressLookup";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => {
    const currentPage = getCurrentPage(state);
    let shipTos: ShipToModel[] = [];
    const isLoading = false;

    if (currentPage.type === "AffinityCreateAccountPage") {
        shipTos = state.affinity_create_account.existingAddresses?.shipTos ?? [];
        // TODO: Update isLoading from an isLoadingAddresses addition to state, flip on start / end of related handlers
    }

    if (currentPage.type === "AffinityPlaceOrderPage") {
        shipTos = state.affinity_place_order.existingAddresses?.shipTos ?? [];
        // TODO: Update isLoading from an isLoadingAddresses addition to state, flip on start / end of related handlers
    }

    if (currentPage.type === "TODOADDRESSPAGE") {
        // TODO: READ COLLECTION FROM ?
        // TODO: Update isLoading from an isLoadingAddresses addition to state, flip on start / end of related handlers
    }

    return {
        shipTos,
        isLoading,
    }
};

const mapDispatchToProps = {
    AddAddress,
    SwitchAddressMode,
};

type AddressesSelectorProps = {
    onAddressSelect?: (value: ShipToModel) => void;
    onAddAddress: (value: AddressType) => void;
};

type Props = AddressesSelectorProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const usePrevious = <T,>(value: T) => {
    const ref = React.useRef<T>();
    React.useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export const AddressesSelector: React.FC<Props> = ({ 
    onAddressSelect, 
    onAddAddress, 
    shipTos, 
    isLoading 
}) => {
    const [isAddingAddress, setIsAddingAddress] = React.useState(false);
    const prevAddresses = usePrevious(shipTos);

    function onSubmit(value: AddressType) {
        onAddAddress(value);
        setIsAddingAddress(false);
    }

    function switchToAddAddressMode() {
        setIsAddingAddress(true);
    }

    if ((!isLoading && shipTos?.length === 0) || isAddingAddress) {
        return (
            <>
                <Typography variant="h3">Add address</Typography>
                <AddressLookup onSubmit={onSubmit} />
            </>
        );
    }

    return (
        <LoadingOverlay loading={isLoading}>
            <CardGridContainer>
                {(isLoading ? prevAddresses : shipTos)?.map(address => (
                    <AddressCard key={address.id} address={address} onAddressSelect={onAddressSelect} />
                ))}
                <AddAdressButton onClick={switchToAddAddressMode} />
            </CardGridContainer>
        </LoadingOverlay>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressesSelector);

export function combineAddress(address: ShipToModel) {
    return [
        address.address1,
        address.address2,
        address.address3,
        address.city,
        address.address4,
        // address.postalCode,
    ]
        .filter(elm => elm)
        .join(", ");
}
